// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".userAddStore {\n  height: 100%;\n  background-color: white;\n  display: flex;\n  flex-direction: column;\n}\n.userAddStore__main {\n  height: 400px;\n  display: flex;\n  margin-bottom: 10px;\n}\n.userAddStore__main .left {\n  min-width: 40%;\n  display: flex;\n  flex-direction: column;\n  margin-right: 10px;\n}\n.userAddStore__main .right {\n  flex: 1;\n  display: block;\n  padding: 10px;\n}\n.userAddStore__footer {\n  display: flex;\n  align-items: center;\n}", ""]);
// Exports
module.exports = exports;
